import { convertToEnglishDigits } from '@shared/lib';
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Fundaward,
  Label,
  Input,
  Button,
  LoadingSpinner,
  FormMessage,
} from '@shared/ui';

import { TFundAwardFormProps, formLanguage } from '../../model';

import { DrawerReward } from './Drawer';

export const FundAwardForm = ({
  form,
  onSubmit,
  isLoading,
  open,
  setOpen,
  data,
}: TFundAwardFormProps) => {
  return (
    <>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className='flex flex-col justify-between gap-4 items-center  w-full h-full px-3 pb-5'
        >
          <div className='flex flex-col gap-4 items-center w-full h-full pt-5'>
            <Fundaward />

            <Label className='h5-bold'>{formLanguage.formPlaceholder}</Label>
            <FormField
              name='code'
              control={form.control}
              render={({ field }) => (
                <FormItem className='w-full mb-9'>
                  <FormControl>
                    <Input
                      {...field}
                      dir='rtl'
                      className='h-[54px] placeholder:!body-12-regular w-full !body-14-regular mx-0 '
                      placeholder={formLanguage.formPlaceholder}
                      type='text'
                      value={field.value || ''}
                      maxLength={15}
                      onChange={(e) => {
                        const cleanedValue = convertToEnglishDigits(e.target.value).replace(
                          /[^A-Za-z0-9]/g,
                          ''
                        );
                        field.onChange(cleanedValue);
                      }}
                    />
                  </FormControl>
                  <FormMessage className='absolute' />
                </FormItem>
              )}
            />
          </div>
          <Button
            className='h-[60px] w-full gap-x-1 items-center flex justify-center grow mb-[env(safe-area-inset-bottom)]'
            type='submit'
            disabled={isLoading}
          >
            {isLoading && <LoadingSpinner />}
            {formLanguage.applyButton}
          </Button>
        </form>
      </Form>
      <DrawerReward open={open} setOpen={setOpen} data={data} />
    </>
  );
};
